import React from 'react'

function StoreUsers() {
  return (
    <div>StoreUsers</div>
  )
}

export default StoreUsers